'use strict'

import { request } from '../../plugins/http'

export default async (orderId) => {
    return await request.get('/autorizacaoPedido', {params : orderId})
}